<template>
    <div>
        <hero></hero>
    </div>
</template>
<script>
import Hero from "./Landing";

export default {
  name: "components",
  components: {
      Hero,
  }
};
</script>
